import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/_shared/_shared.module';

@Component({
  selector: 'app-sellos',
  templateUrl: './sellos.component.html',
  styleUrls: ['./sellos.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
  ]
})

export class SellosComponent {
  @Input() tipoOperacionCodigo: string;
  @Input() isPanelInversor: boolean;
  @Input() size: number = 45;
}
